import { useState, VFC } from 'react'
import { DotsIcon } from 'src/assets/svgs'
import {
  black,
  _popupbg,
  _tooltiphover,
  _tooltipshadow,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'

type PopUpMenuProps = {
  actions: {
    label: string
    onClick: VoidFunction
  }[]
}
export const PopUpMenu: VFC<PopUpMenuProps> = ({ actions }) => {
  const [showMenu, setShowMenu] = useState(false)
  return (
    <>
      <PopUpMenuDiv>
        <button onClick={() => setShowMenu(!showMenu)}>
          <DotsIcon />
        </button>
        {showMenu && (
          <>
            <OuterDiv onClick={() => setShowMenu(false)} />
            <MenuContent onClick={(e) => e.stopPropagation()}>
              {actions.map(({ label, onClick }) => (
                <MenuItemButton
                  key={label}
                  onClick={() => {
                    onClick()
                  }}
                >
                  {label}
                </MenuItemButton>
              ))}
            </MenuContent>
          </>
        )}
      </PopUpMenuDiv>
    </>
  )
}
const MenuContent = styled.div`
  position: absolute;
  right: 0;
  z-index: 1;
  width: 152px;
  text-align: center;
  font-weight: ${fontWeightBold};
`
const MenuItemButton = styled.button`
  display: block;
  width: 100%;
  background-color: ${_popupbg};
  box-shadow: ${_tooltipshadow};
  padding: 8px 16px;
  color: ${black};
  font-size: 12px;
  :hover {
    background-color: ${_tooltiphover};
    color: ${_popupbg};
  }
  :first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  :last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`
const OuterDiv = styled.div`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
`
const PopUpMenuDiv = styled.div`
  position: relative;
  z-index: 1;
`
